<template>
  <div v-if="isLoggedIn" class="mt-1">
    <v-tabs
      v-model="active"
      color="indigo"
      centered
      dark
      slider-color="yellow"
    >
      <v-tab
        v-for="(status, index) in statuses"
        :key="index"
        ripple
        @click="next(status.status_id)"
      >
         {{ status.title }}
      </v-tab>
      <v-tab-item
        v-for="(status, index) in statuses"
        :key="index"
        
      >
       
        <v-card flat v-if="status.status_id == 2 && active == 0">
            <Pending></Pending>
        </v-card>
        <v-card flat v-else-if="status.status_id == 3 && active == 1">
            <Modified></Modified>
        </v-card>
        <v-card flat v-else-if="status.status_id == 4 && active == 2">
            <Verified></Verified>
        </v-card>
        <v-card flat v-else-if="status.status_id == 5 && active == 3">
            <Canceled></Canceled>
        </v-card>
        <v-card flat v-else>
            <Failed></Failed>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- <div class="text-xs-center mt-3">
      <button class="button" flat @click="next">Next Tab</button>
    </div> -->
  </div>
  <div centered v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4 md4></v-flex>
        <v-flex xs4 md4 align-end>
          <v-card>
            <v-card-text color="indigo">
                You are not logged in!
            </v-card-text>
          </v-card>
          <router-link to="/signin">
            <v-btn color="#ff2e2e"><v-icon>lock_open</v-icon> login</v-btn>
          </router-link>
        </v-flex>
        <v-flex xs4 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Pending from './Pending'
import Modified from './Modified'
import Verified from './Verified'
import Canceled from './Canceled'
import Failed from './Failed'

import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        active: null,
        statuses:[
          {'title': 'pending', 'status_id': 2}, 
          {'title': 'required modification', 'status_id': 3},
          {'title': 'verified', 'status_id': 4},
          {'title': 'canceled', 'status_id': 5},
          {'title': 'failed', 'status_id': 6},
        ]
      }
    },
    components: {
      Pending,
      Modified,
      Verified,
      Canceled,
      Failed
    },
    computed:{
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg'])     
    },

    created () {
      this.moneyTransactionList(2)
    },

    methods: {
      next (status) {
       this.moneyTransactionList(status);
       this.active = parseInt(status) - 2;       
      //  console.log(this.active);
      },     
      moneyTransactionList: function(paymentStatusId){
        // console.log("paymentStatusId "+ paymentStatusId);
        this.$store.dispatch("changePaymentStatus", ["payment-status", paymentStatusId, "", 1, 5]);
      }
    }
  }
</script>

<style lang="stylus" scoped>
.button {
  font-size: 16px;
  background: #3F51B5;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color:white;
}
  
</style>